/**
 * @flow
 */
'use strict';

export const allergyCodes = [
{"code":"Acetaminophen"},
{"code":"Advil"},
{"code":"Alcohol"},
{"code":"Almond"},
{"code":"Alphagan"},
{"code":"Amoxicillin"},
{"code":"Amoxil"},
{"code":"Amiloxyn"},
{"code":"Anaprox"},
{"code":"Anesthetic"},
{"code":"Animal"},
{"code":"Anti-inflammatory"},
{"code":"Antibiotic"},
{"code":"Apple"},
{"code":"Aquinil"},
{"code":"Aspirin"},
{"code":"Atorvastatin"},
{"code":"Eggplant"},
{"code":"Augmentin"},
{"code":"Avelox"},
{"code":"Avenox"},
{"code":"Azithromycin"},
{"code":"Bactrin"},
{"code":"Bee"},
{"code":"Benadryl"},
{"code":"Bezafibre"},
{"code":"Bezalip"},
{"code":"Biaxin"},
{"code":"Birch"},
{"code":"Caffeine"},
{"code":"Capsaicin"},
{"code":"Curry"},
{"code":"Cats"},
{"code":"Cecla"},
{"code":"Cefaclor"},
{"code":"Cefzil"},
{"code":"Celebrex"},
{"code":"Cephalosporin"},
{"code":"Cephazil"},
{"code":"Chery"},
{"code":"Chlorine"},
{"code":"Clarithromycin"},
{"code":"Clavulin"},
{"code":"Clindamycin"},
{"code":"Codeine"},
{"code":"Cortisone"},
{"code":"Demerol"},
{"code":"Dextrometorphan"},
{"code":"Diachylon"},
{"code":"Dibucaine"},
{"code":"Dilaudid"},
{"code":"Dog"},
{"code":"Dust"},
{"code":"Eggs"},
{"code":"Empracet"},
{"code":"Epinephrine"},
{"code":"Erythromycin"},
{"code":"Estrogel"},
{"code":"Fenofibrate"},
{"code":"Fentanyl"},
{"code":"Fish"},
{"code":"Flour"},
{"code":"Fluviral"},
{"code":"Food coloring"},
{"code":"Fruits"},
{"code":"Fucithalmic"},
{"code":"Fur"},
{"code":"Gluten"},
{"code":"Grapefruit"},
{"code":"Grass"},
{"code":"Horse"},
{"code":"Hydromax"},
{"code":"Hydromorphone"},
{"code":"Ibuprofen"},
{"code":"Imitrex"},
{"code":"Insect bite"},
{"code":"Iodine"},
{"code":"Keflex"},
{"code":"Kiwi"},
{"code":"Lactose"},
{"code":"Latex"},
{"code":"Lavander"},
{"code":"Lecithin"},
{"code":"Lentils"},
{"code":"Lidocaine"},
{"code":"Lincomycin"},
{"code":"Lobster"},
{"code":"Lopressor"},
{"code":"Lorazepam"},
{"code":"Macrolides"},
{"code":"Corn"},
{"code":"Mandarin"},
{"code":"Mango"},
{"code":"Maxidex"},
{"code":"Maxiran"},
{"code":"Melon"},
{"code":"Meperidine"},
{"code":"Mercury"},
{"code":"Metal"},
{"code":"Milk"},
{"code":"Moissisures"},
{"code":"Morphine"},
{"code":"Motrin"},
{"code":"Mustard"},
{"code":"Naproxen"},
{"code":"Nexium"},
{"code":"Nickel"},
{"code":"Novamoxan"},
{"code":"Nuts"},
{"code":"Paint"},
{"code":"Pantoloc"},
{"code":"Peaches"},
{"code":"Peanuts"},
{"code":"Peas"},
{"code":"Penicillin"},
{"code":"Perfume"},
{"code":"Pineapple"},
{"code":"Pisanlit"},
{"code":"Pollen"},
{"code":"Polysporin"},
{"code":"Pravachol"},
{"code":"Quinoa"},
{"code":"Rabbit"},
{"code":"Ragweed"},
{"code":"Rosasol"},
{"code":"Seafood"},
{"code":"Septra"},
{"code":"Serax"},
{"code":"Sesame"},
{"code":"Sheep hair"},
{"code":"Shellfish"},
{"code":"Shrimp"},
{"code":"Soap"},
{"code":"Soya"},
{"code":"Strawberries"},
{"code":"Sulfa"},
{"code":"Sun"},
{"code":"Sunscreen"},
{"code":"Tegretol"},
{"code":"Tetanus"},
{"code":"Tetracycline"},
{"code":"Timolol"},
{"code":"Tobradex"},
{"code":"Tobramycin"},
{"code":"Tobrex"},
{"code":"Trees"},
{"code":"Tylenol"},
{"code":"Valium"},
{"code":"Valtrex"},
{"code":"Vinaigre"},
{"code":"Wasp"},
{"code":"Xylocaine"},
{"code":"Zinc"},
{"code":"Zithromax"}
]

export const allergyReactionCodes = [
{"code":"Abdominal Cramps"},
{"code":"Abdominal Pain"},
{"code":"Anaphylaxis"},
{"code":"Anxiety"},
{"code":"Chest Discomfort"},
{"code":"Chest Tightness"},
{"code":"Diarrhea"},
{"code":"Difficulty Breathing"},
{"code":"Difficulty Swallowing"},
{"code":"Dizziness"},
{"code":"Eye Swelling"},
{"code":"Facial Swelling"},
{"code":"Fear"},
{"code":"Feeling of Apprehension"},
{"code":"Headache"},
{"code":"Hives"},
{"code":"Itching"},
{"code":"Light-Headedness"},
{"code":"Nasal Congestion"},
{"code":"Nausea"},
{"code":"Palpitations"},
{"code":"Photosensitivity"},
{"code":"Stomach Cramps"},
{"code":"Tongue Swelling"},
{"code":"Unconsciousness"},
{"code":"Vomiting"},
{"code":"Watery Eye"},
{"code":"Weakness"},
{"code":"Wheezing"},
{"code":"Urticaria"}
]
